module.exports = __webpack_public_path__ + "static/media/Hola_iPad.287faf08.mov";